function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { Component, createRef } from 'react';
import { SearchButton } from './search_button';
import { SearchQueryWidget } from './query';
import DatabasesTree from './databases_tree';
import { Databases } from './databases';
import _ from 'underscore';
import { Options } from 'options';
import QueryStats from 'query_stats';

/**
 * Search form.
 *
 * Top level component that initialises and holds all other components, and
 * facilitates communication between them.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Form = /*#__PURE__*/function (_Component) {
  function Form(props) {
    var _this;
    _classCallCheck(this, Form);
    _this = _callSuper(this, Form, [props]);
    _this.state = {
      databases: [],
      preSelectedDbs: [],
      currentlySelectedDbs: [],
      preDefinedOpts: {},
      tree: {},
      residuesInQuerySequence: 0,
      blastMethod: ''
    };
    _this.useTreeWidget = _this.useTreeWidget.bind(_this);
    _this.determineBlastMethods = _this.determineBlastMethods.bind(_this);
    _this.handleSequenceTypeChanged = _this.handleSequenceTypeChanged.bind(_this);
    _this.handleSequenceChanged = _this.handleSequenceChanged.bind(_this);
    _this.handleDatabaseTypeChanged = _this.handleDatabaseTypeChanged.bind(_this);
    _this.handleDatabaseSelectionChanged = _this.handleDatabaseSelectionChanged.bind(_this);
    _this.handleAlgoChanged = _this.handleAlgoChanged.bind(_this);
    _this.handleFormSubmission = _this.handleFormSubmission.bind(_this);
    _this.formRef = /*#__PURE__*/createRef();
    _this.query = /*#__PURE__*/createRef();
    _this.button = /*#__PURE__*/createRef();
    _this.setButtonState = _this.setButtonState.bind(_this);
    return _this;
  }
  _inherits(Form, _Component);
  return _createClass(Form, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      /**
      * Fetch data to initialise the search interface from the server. These
      * include list of databases to search against, advanced options to
      * apply when an algorithm is selected, and a query sequence that
      * the user may want to search in the databases.
      */
      var search = location.search.split(/\?|&/).filter(Boolean);
      var job_id = sessionStorage.getItem('job_id');
      if (job_id) {
        search.unshift("job_id=".concat(job_id));
      }
      $.getJSON("searchdata.json?".concat(search.join('&')), function (data) {
        var _this2 = this;
        /* Update form state (i.e., list of databases and predefined
         * advanced options.
         */
        this.setState({
          tree: data['tree'],
          databases: data['database'],
          preSelectedDbs: data['preSelectedDbs'],
          preDefinedOpts: data['options'],
          blastTaskMap: data['blastTaskMap'],
          currentlySelectedDbs: data['preSelectedDbs'] || []
        }, function () {
          _this2.handleDatabaseSelectionChanged(_this2.state.currentlySelectedDbs);
          _this2.handleFirstSelectionDB();
          _this2.setBlastMethods();
        });

        /* Pre-populate the form with server sent query sequences
         * (if any).
         */
        if (data['query']) {
          this.query.current.value(data['query']);
        }

        // DB selection
        setTimeout(function () {
          _this2.preselectDatabases(_this2.state.preSelectedDbs);
        }, 0);
        setTimeout(function () {
          $('.jstree_div').click();
        }, 1000);
      }.bind(this));

      /* Enable submitting form on Cmd+Enter */
      $(document).on('keydown', function (e) {
        var $button = $('#method');
        if (!$button.is(':disabled') && e.ctrlKey && e.key === 'Enter') {
          $button.trigger('click');
        }
      });
    }
  }, {
    key: "handleFirstSelectionDB",
    value: function handleFirstSelectionDB() {
      var firstSelectedDb = this.state.preSelectedDbs != null ? this.state.preSelectedDbs[0].type : null;
      if (firstSelectedDb) {
        this.handleDatabaseTypeChanged(firstSelectedDb);
      }
    }
  }, {
    key: "setBlastMethods",
    value: function setBlastMethods() {
      var methods = this.determineBlastMethods();
      if (methods.length > 0) {
        this.setState({
          blastMethod: methods[0]
        });
      }
    }
  }, {
    key: "preselectDatabases",
    value: function preselectDatabases(preSelectedDbs) {
      var _this3 = this;
      if (preSelectedDbs) {
        preSelectedDbs.forEach(function (db) {
          var matchCheckbox = _this3.formRef.current.querySelector("input.checkbox-database[value=\"".concat(db.id, "\"]"));
          if (matchCheckbox) {
            matchCheckbox.click();
            matchCheckbox.checked = true;
          }
        });
      }
    }
  }, {
    key: "useTreeWidget",
    value: function useTreeWidget() {
      return !_.isEmpty(this.state.tree);
    }
  }, {
    key: "handleFormSubmission",
    value: function handleFormSubmission(evt) {
      evt.preventDefault();
      var form = this.formRef.current;
      document.getElementById('overlay').style.display = 'block';
      var formData = new FormData(form);
      formData.append('method', this.button.current.state.methods[0]);
      fetch(window.location.href, {
        method: 'POST',
        body: formData
      }).then(function (res) {
        //remove overlay when form is submitted
        document.getElementById('overlay').style.display = 'none';
        // redirect
        if (res.redirected && res.url) {
          // setTimeout is needed here as a workaround because safari doesnt allow async calling of window.open
          // so setTimeout makes the method get called on the main thread.
          setTimeout(function () {
            window.open(res.url, $('#toggleNewTab').is(':checked') ? '_blank' : '_self');
          }, 0);
        }
      });
    }
  }, {
    key: "determineBlastMethods",
    value: function determineBlastMethods() {
      var database_type = this.databaseType;
      var sequence_type = this.sequenceType;
      if (this.query.current.isEmpty()) {
        return [];
      }

      //database type is always known
      switch (database_type) {
        case 'protein':
          switch (sequence_type) {
            case undefined:
              return ['blastp', 'blastx'];
            case 'protein':
              return ['blastp'];
            case 'nucleotide':
              return ['blastx'];
          }
          break;
        case 'nucleotide':
          switch (sequence_type) {
            case undefined:
              return ['tblastn', 'blastn', 'tblastx'];
            case 'protein':
              return ['tblastn'];
            case 'nucleotide':
              return ['blastn', 'tblastx'];
          }
          break;
      }
      return [];
    }
  }, {
    key: "handleSequenceChanged",
    value: function handleSequenceChanged(residuesInQuerySequence) {
      if (residuesInQuerySequence !== this.state.residuesInQuerySequence) this.setState({
        residuesInQuerySequence: residuesInQuerySequence
      });
    }
  }, {
    key: "handleSequenceTypeChanged",
    value: function handleSequenceTypeChanged(type) {
      this.sequenceType = type;
      this.setButtonState();
    }
  }, {
    key: "handleDatabaseTypeChanged",
    value: function handleDatabaseTypeChanged(type) {
      this.databaseType = type;
      this.setButtonState();
    }
  }, {
    key: "setButtonState",
    value: function setButtonState() {
      this.button.current.setState({
        hasQuery: !this.query.current.isEmpty(),
        hasDatabases: !!this.databaseType,
        methods: this.determineBlastMethods()
      });
    }
  }, {
    key: "handleDatabaseSelectionChanged",
    value: function handleDatabaseSelectionChanged(selectedDbs) {
      if (!_.isEqual(selectedDbs, this.state.currentlySelectedDbs)) this.setState({
        currentlySelectedDbs: selectedDbs
      });
    }
  }, {
    key: "handleAlgoChanged",
    value: function handleAlgoChanged(algo) {
      if (algo in this.state.preDefinedOpts) {
        this.setState({
          blastMethod: algo
        });
      } else {
        this.setState({
          blastMethod: ''
        });
      }
    }
  }, {
    key: "residuesInSelectedDbs",
    value: function residuesInSelectedDbs() {
      return this.state.currentlySelectedDbs.reduce(function (sum, db) {
        return sum + parseInt(db.ncharacters, 10);
      }, 0);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("div", {
          id: "overlay",
          style: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vw',
            background: 'rgba(0, 0, 0, 0.2)',
            display: 'none',
            zIndex: 99
          }
        }), /*#__PURE__*/_jsxs("div", {
          className: "fixed top-0 left-0 w-full max-h-8 px-8",
          "data-notifications": true,
          id: "notifications",
          children: [/*#__PURE__*/_jsx(FastqNotification, {}), /*#__PURE__*/_jsx(NucleotideNotification, {}), /*#__PURE__*/_jsx(ProteinNotification, {}), /*#__PURE__*/_jsx(MixedNotification, {})]
        }), /*#__PURE__*/_jsxs("form", {
          id: "blast",
          ref: this.formRef,
          onSubmit: this.handleFormSubmission,
          children: [/*#__PURE__*/_jsx("input", {
            type: "hidden",
            name: "_csrf",
            value: document.querySelector('meta[name="_csrf"]').content
          }), /*#__PURE__*/_jsxs("div", {
            className: "px-4",
            children: [/*#__PURE__*/_jsx(SearchQueryWidget, {
              ref: this.query,
              onSequenceTypeChanged: this.handleSequenceTypeChanged,
              onSequenceChanged: this.handleSequenceChanged
            }), this.useTreeWidget() ? /*#__PURE__*/_jsx(DatabasesTree, {
              databases: this.state.databases,
              tree: this.state.tree,
              preSelectedDbs: this.state.preSelectedDbs,
              onDatabaseTypeChanged: this.handleDatabaseTypeChanged,
              onDatabaseSelectionChanged: this.handleDatabaseSelectionChanged
            }) : /*#__PURE__*/_jsx(Databases, {
              databases: this.state.databases,
              preSelectedDbs: this.state.preSelectedDbs,
              onDatabaseTypeChanged: this.handleDatabaseTypeChanged,
              onDatabaseSelectionChanged: this.handleDatabaseSelectionChanged
            }), /*#__PURE__*/_jsx(Options, {
              blastMethod: this.state.blastMethod,
              predefinedOptions: this.state.preDefinedOpts[this.state.blastMethod] || {},
              blastTasks: (this.state.blastTaskMap || {})[this.state.blastMethod]
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "py-6"
          }), " ", /*#__PURE__*/_jsxs("div", {
            className: "pb-4 pt-2 px-4 sticky bottom-0 md:flex flex-row md:space-x-4 items-center justify-end bg-gradient-to-t to-gray-100/90 from-white/90",
            children: [/*#__PURE__*/_jsx(QueryStats, {
              residuesInQuerySequence: this.state.residuesInQuerySequence,
              numberOfDatabasesSelected: this.state.currentlySelectedDbs.length,
              residuesInSelectedDbs: this.residuesInSelectedDbs(),
              currentBlastMethod: this.state.blastMethod
            }), /*#__PURE__*/_jsxs("label", {
              className: "text-seqblue hover:seqorange cursor-pointer block my-4 md:my-2",
              children: [/*#__PURE__*/_jsx("input", {
                type: "checkbox",
                id: "toggleNewTab"
              }), " Open results in new tab"]
            }), /*#__PURE__*/_jsx(SearchButton, {
              ref: this.button,
              onAlgoChanged: this.handleAlgoChanged
            })]
          })]
        })]
      });
    }
  }]);
}(Component);
var ProteinNotification = /*#__PURE__*/function (_Component2) {
  function ProteinNotification() {
    _classCallCheck(this, ProteinNotification);
    return _callSuper(this, ProteinNotification, arguments);
  }
  _inherits(ProteinNotification, _Component2);
  return _createClass(ProteinNotification, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx("div", {
        "data-role": "notification",
        id: "protein-sequence-notification",
        style: {
          display: 'none'
        },
        children: /*#__PURE__*/_jsx("div", {
          className: "bg-blue-100 border rounded border-blue-800 px-4 py-2 my-2",
          children: "Detected: amino-acid sequence(s)."
        })
      });
    }
  }]);
}(Component);
var NucleotideNotification = /*#__PURE__*/function (_Component3) {
  function NucleotideNotification() {
    _classCallCheck(this, NucleotideNotification);
    return _callSuper(this, NucleotideNotification, arguments);
  }
  _inherits(NucleotideNotification, _Component3);
  return _createClass(NucleotideNotification, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx("div", {
        "data-role": "notification",
        id: "nucleotide-sequence-notification",
        style: {
          display: 'none'
        },
        children: /*#__PURE__*/_jsx("div", {
          className: "bg-blue-100 border rounded border-blue-800 px-4 py-2 my-2",
          children: "Detected: nucleotide sequence(s)."
        })
      });
    }
  }]);
}(Component);
var FastqNotification = /*#__PURE__*/function (_Component4) {
  function FastqNotification() {
    _classCallCheck(this, FastqNotification);
    return _callSuper(this, FastqNotification, arguments);
  }
  _inherits(FastqNotification, _Component4);
  return _createClass(FastqNotification, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx("div", {
        "data-role": "notification",
        id: "fastq-sequence-notification",
        style: {
          display: 'none'
        },
        children: /*#__PURE__*/_jsx("div", {
          className: "bg-blue-100 border rounded border-blue-800 px-4 py-2 my-2",
          children: "Detected FASTQ and automatically converted to FASTA."
        })
      });
    }
  }]);
}(Component);
var MixedNotification = /*#__PURE__*/function (_Component5) {
  function MixedNotification() {
    _classCallCheck(this, MixedNotification);
    return _callSuper(this, MixedNotification, arguments);
  }
  _inherits(MixedNotification, _Component5);
  return _createClass(MixedNotification, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx("div", {
        "data-role": "notification",
        id: "mixed-sequence-notification",
        style: {
          display: 'none'
        },
        children: /*#__PURE__*/_jsx("div", {
          className: "alert-danger col-md-10 col-md-offset-1",
          children: "Error: mixed nucleotide and amino-acid sequences detected."
        })
      });
    }
  }]);
}(Component);